@if (license$ | async; as license) {
  @if (courseEndsAfterLicense(license) && licenseExpirationHandler.isExpiringLicenseRequiringWarning(license) && !isWhiteLabel) {
    @if (!actionNeeded(license) && (hasOtherAvailableLicense$ | async) === false) {
      <div
        class="renewal-messaging no-action">
        <span
          class="message-with-tooltip"
          tabindex="0"
        [matTooltip]="getMessageTranslation(license).tooltip | translate">{{ getMessageTranslation(license).message | translate : {days: getMessageTranslation(license).numDays} }}</span>
      </div>
    }
    @if (actionNeeded(license) || (hasOtherAvailableLicense$ | async)) {
      <div
        class="renewal-messaging with-action">
        <span class="message" [ngClass]="license.salesforce_license.is_free_trial ? 'free-trial-red' : 'default-grey'"><!--
          -->{{ getMessageTranslation(license).message | translate : {days: getMessageTranslation(license).numDays} }}<!--
        --></span>
        @if (licenseExpirationHandler.isExpiringLicenseRequiringRenewal(license)) {
          <button
            class="secondary-btn renew-btn"
            (click)="renewLicense(license)"
            [translate]="license.salesforce_license.is_free_trial ? 'license-plan-purchase':'expiring-license_renew'">
          </button>
        }
        @if (license.salesforce_license.has_renewal) {
          <button
            class="secondary-btn move-btn"
            [disabled]="loading$ | async"
            (click)="moveFolder()"
            translate>
            expiring-license_move-course
            @if (loading$ | async) {
              <i class="ficon-spinner ficon-spin" aria-live="polite" attr.aria-label="{{'common_loading'| translate}}"></i>
            }
          </button>
        }
        @if (hasOtherAvailableLicense$ | async) {
          <button
            class="secondary-btn edit-btn"
            [disabled]="loading$ | async"
            (click)="editFolder()"
            translate>
            course-menu_edit-course
            @if (loading$ | async) {
              <i class="ficon-spinner ficon-spin" aria-live="polite" attr.aria-label="{{'common_loading'| translate}}"></i>
            }
          </button>
        }
      </div>
    }
  }
}
